import type { Invoice } from "~/shared/schemas/invoice-schema.ts";

const MIN_INVOICE_AMOUNT = 0.01;

export function getInvalidAmountInvoices(
	selectedInvoices: Invoice[],
	invoiceAmounts: Record<string, number>,
	fallbackAmount = 0,
): Invoice[] {
	return selectedInvoices.filter((invoice) => {
		const amtPaid = invoiceAmounts[String(invoice.invoiceID)] ?? fallbackAmount;
		return Number.isNaN(amtPaid) || amtPaid < MIN_INVOICE_AMOUNT;
	});
}

export function formatInvalidInvoiceAmountMessage(invoices: Invoice[]): string {
	const poNumbers = invoices.map((invoice) => String(invoice.poNumber));
	return `Selected invoice(s) must have a payment amount of at least $0.01: ${poNumbers.join(", ")}`;
}
